/**
 * UTF-8 safe Base64 encoding/decoding for PropertyFilter `?f=` query payloads.
 * Matches the legacy v1 encoding and the booking-report email deeplink format.
 */

export function encodeFilterPayload(obj: unknown): string {
  const json = JSON.stringify(obj);
  return btoa(unescape(encodeURIComponent(json)));
}

export function decodeFilterPayload<T = unknown>(encoded: string): T | null {
  try {
    const binary = atob(encoded);
    const json = decodeURIComponent(escape(binary));
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}
